import ColumnChart from '../../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function CancelRate ({ data }) {
  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const cancelRate = [
    ['Mês', 'Taxa de cancelamento (%)'],
    ...Object.entries (data).map (([month, values]) => [
      month, Number (values.rate) || 0
    ])
  ]

  return (
    <InfoContainer>
      <SubTitle>Taxa de cancelamento (%)</SubTitle>
      <ColumnChart
        data={cancelRate}
        legendPosition='top'
        options={{
          isStacked: false,
          height: 350,
          colors: ['#FF3939'],
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Taxa (%)',
            minValue: 0,
            titleTextStyle: {
              bold: true
            }
          }
        }}
      />
    </InfoContainer>
  )
}
